import "./product.css";

const Product = ({img,link,title}) => {
  return (
    <div className="p" >
      <a href={link} target="_blank" rel="noreferrer">
        <img src={img} alt="" className="p-img" />
        {title}
      </a>
    </div>
  );
};

export default Product;